var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { UIComponent, customPropTypes, createShorthandFactory, commonPropTypes, isFromKeyboard, } from '../../lib';
import Icon from '../Icon/Icon';
import Button from '../Button/Button';
import Text from '../Text/Text';
import Slot from '../Slot/Slot';
import { attachmentBehavior } from '../../lib/accessibility';
/**
 * An Attachment displays a file attachment.
 */
var Attachment = /** @class */ (function (_super) {
    __extends(Attachment, _super);
    function Attachment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isFromKeyboard: false,
        };
        _this.actionHandlers = {
            performClick: function (event) { return _this.performClick(event); },
        };
        _this.performClick = function (e) {
            e.stopPropagation();
            _this.handleClick(e);
        };
        _this.handleClick = function (e) {
            var disabled = _this.props.disabled;
            if (disabled) {
                e.preventDefault();
                return;
            }
            _.invoke(_this.props, 'onClick', e, _this.props);
        };
        _this.handleFocus = function (e) {
            _this.setState({ isFromKeyboard: isFromKeyboard() });
            _.invoke(_this.props, 'onFocus', e, _this.props);
        };
        return _this;
    }
    Attachment.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, styles = _a.styles, variables = _a.variables, accessibility = _a.accessibility;
        var _b = this.props, header = _b.header, description = _b.description, icon = _b.icon, action = _b.action, progress = _b.progress;
        return (React.createElement(ElementType, __assign({ className: classes.root, onClick: this.handleClick, onFocus: this.handleFocus }, accessibility.attributes.root, accessibility.keyHandlers.root, rest),
            icon && (React.createElement("div", { className: classes.icon }, Icon.create(icon, {
                defaultProps: { size: 'larger' },
            }))),
            (header || description) && (React.createElement("div", { className: classes.content },
                Text.create(header, {
                    defaultProps: { styles: styles.header },
                }),
                Text.create(description, {
                    defaultProps: { styles: styles.description },
                }))),
            action && (React.createElement("div", { className: classes.action }, Button.create(action, {
                defaultProps: { iconOnly: true, text: true },
            }))),
            !_.isNil(progress) &&
                Slot.create('', {
                    defaultProps: { className: classes.progress },
                })));
    };
    Attachment.className = 'ui-attachment';
    Attachment.displayName = 'Attachment';
    Attachment.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.func, action: customPropTypes.itemShorthand, actionable: PropTypes.bool, description: customPropTypes.itemShorthand, header: customPropTypes.itemShorthand, icon: customPropTypes.itemShorthand, progress: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) });
    Attachment.defaultProps = {
        accessibility: attachmentBehavior,
    };
    return Attachment;
}(UIComponent));
Attachment.create = createShorthandFactory(Attachment, 'header');
export default Attachment;
